// Rechtstexte – Vorlage mit Platzhaltern. Bitte vor Veröffentlichung vollständig ergänzen und prüfen lassen.
const P = (t) => t;

export const IMPRESSUM = {
  title: "Impressum",
  sections: [
    {
      h: "Angaben gemäß § 5 DDG",
      p: [
        "GRÜNWIRBEL",
        "Inhaber: Jonas Feierstein",
        "Lehrgasse 6",
        "76863 Herxheim",
      ],
    },
    {
      h: "Kontakt",
      p: ["Telefon: 017670718231", "E-Mail: gruenwirbel@gmail.com"],
    },
    {
      h: "Umsatzsteuer",
      p: ["Kleinunternehmer gemäß § 19 UStG – es wird keine Umsatzsteuer berechnet und daher auch keine Umsatzsteuer-Identifikationsnummer angegeben."],
    },
    {
      h: "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV",
      p: ["Jonas Feierstein", "Lehrgasse 6, 76863 Herxheim"],
    },
    {
      h: "Verbraucherstreitbeilegung",
      p: ["Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen."],
    },
    {
      h: "Haftung für Inhalte",
      p: [
        "Die Inhalte dieser Website wurden mit Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.",
      ],
    },
    {
      h: "Bildnachweise",
      p: ["Gartenfotos: Unsplash (unsplash.com). Foto von Jonas Feierstein: GRÜNWIRBEL. Rasen- und Rasenmäher-Grafik der Startanimation: mit KI erstellt."],
    },
  ],
};

export const DATENSCHUTZ = {
  title: "Datenschutzerklärung",
  sections: [
    {
      h: "1. Verantwortlicher",
      p: [
        "Verantwortlich für die Datenverarbeitung auf dieser Website im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:",
        "GRÜNWIRBEL, Inhaber Jonas Feierstein, Lehrgasse 6, 76863 Herxheim",
        "E-Mail: gruenwirbel@gmail.com",
        "Telefon: 017670718231",
      ],
    },
    {
      h: "2. Allgemeines",
      p: [
        "Wir verarbeiten personenbezogene Daten nur, soweit dies für den Betrieb dieser Website und die Bearbeitung Ihrer Anfragen erforderlich ist. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.",
      ],
    },
    {
      h: "3. Hosting und Server-Logfiles",
      p: [
        "Diese Website wird über die Plattform Emergent gehostet.",
        "Beim Aufruf der Website werden technisch notwendige Informationen automatisch erfasst (z. B. IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene Seite, Browsertyp). Diese Daten dienen der sicheren und stabilen Bereitstellung der Website. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem sicheren Betrieb).",
      ],
    },
    {
      h: "4. Kontaktformular und E-Mail",
      p: [
        "Wenn Sie uns über das Anfrageformular oder per E-Mail kontaktieren, verarbeiten wir Ihre Angaben (Name, E-Mail-Adresse oder Telefonnummer, gewünschte Leistung, Nachricht), um Ihre Anfrage zu beantworten und gegebenenfalls ein Angebot zu erstellen.",
        "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Anbahnung eines Vertrags) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Beantwortung von Anfragen).",
        "Die Angaben aus dem Formular werden in einer Datenbank gespeichert und zusätzlich per E-Mail an gruenwirbel@gmail.com weitergeleitet. Für den E-Mail-Versand wird ein technischer Dienst der Plattform Emergent eingesetzt. Der Empfang erfolgt über ein Postfach bei Google (Gmail). Dabei kann eine Übermittlung in Drittländer wie die USA stattfinden.",
        "Wir löschen Ihre Anfrage, sobald sie abschließend bearbeitet ist und keine gesetzlichen Aufbewahrungspflichten (z. B. bei Vertragsabschluss) entgegenstehen.",
        "WhatsApp: Auf der Website gibt es einen Link, über den Sie uns per WhatsApp schreiben können. Erst wenn Sie den Link nutzen und eine Nachricht senden, werden Daten (z. B. Telefonnummer, Nachricht, Fotos) über WhatsApp (WhatsApp Ireland Limited, Merrion Road, Dublin 4, Irland) übertragen. Die Nutzung ist freiwillig; alternativ erreichen Sie uns per E-Mail oder Telefon.",
      ],
    },
    {
      h: "5. Externe Inhalte (Schriftarten und Bilder)",
      p: [
        "Diese Website lädt Schriftarten von Google Fonts (Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland) sowie Bilder vom Dienst Unsplash. Beim Laden wird Ihre IP-Adresse an die jeweiligen Server übermittelt, auch in Drittländer wie die USA. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (einheitliche, ansprechende Darstellung).",
      ],
    },
    {
      h: "6. Plattformdienste",
      p: [
        "Über die Website-Plattform Emergent wird der Dienst PostHog eingebunden, der der technischen Analyse und Fehlererkennung dient. Dabei können Nutzungsdaten wie aufgerufene Seiten, Geräte- und Browserinformationen sowie die IP-Adresse verarbeitet werden, auch in Drittländern wie den USA.",
      ],
    },
    {
      h: "7. Cookies",
      p: [
        "Diese Website setzt selbst keine Cookies zu Werbezwecken. Der in Abschnitt 6 genannte Plattformdienst kann Cookies oder vergleichbare Speichertechniken im Browser verwenden.",
      ],
    },
    {
      h: "8. Ihre Rechte",
      p: [
        "Sie haben jederzeit das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16 DSGVO), Löschung (Art. 17 DSGVO), Einschränkung der Verarbeitung (Art. 18 DSGVO), Datenübertragbarkeit (Art. 20 DSGVO) sowie Widerspruch gegen die Verarbeitung (Art. 21 DSGVO). Eine erteilte Einwilligung können Sie jederzeit mit Wirkung für die Zukunft widerrufen.",
        "Wenden Sie sich dazu einfach per E-Mail an gruenwirbel@gmail.com.",
        "Sie haben außerdem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren. Zuständig für uns ist: Der Landesbeauftragte für den Datenschutz und die Informationsfreiheit Rheinland-Pfalz, Hintere Bleiche 34, 55116 Mainz.",
      ],
    },
    {
      h: "9. SSL-/TLS-Verschlüsselung",
      p: ["Diese Website nutzt aus Sicherheitsgründen eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie an „https://“ in der Adresszeile Ihres Browsers."],
    },
  ],
};
